/****************************************
 * BLOCK THREE COLUMNS
 */

function setImage(className, backgroundSize) {
  var image = $(className).val()
  $('.three-columns-block').css({
    'background-image': 'url(' + image + ')',
    'background-size': backgroundSize
  })
}


$(window).on('resize', function (e) {
  if (window.innerWidth <= 767) {
    setImage('.three-col-hidden', '100%')
  } else {
    setImage('.three-col-hidden-big', 'cover')
  }
})

if (window.innerWidth <= 767) {
  setImage('.three-col-hidden', '100%')
}

/****************************************
 * BLOCK INGREDIENTS
 */
var enlarged = false;
$('.see-all').on('click', function (e) {
  e.preventDefault()
  enlarged = !enlarged;
  if (enlarged) {
    $('.ingredients-section .page-width').css({ 'height': 'auto' })
    $('.ingredients-section').css({ 'height': 'auto' })
    $(this).html('See less <span class="rotated">&nbsp;</span>');
    $(this).removeClass('black-gradient');
    $(this).addClass('enlarged');
  } else {
    $('.ingredients-section .page-width').css({ 'height': '523px' })
    $('.ingredients-section').css({ 'height': '592px' })
    $(this).html('See all <span>&nbsp;</span>');
    $(this).addClass('black-gradient');
    $(this).removeClass('enlarged');
  }
})

/****************************************
 * NOTIFY ME
 */
$('.notify-me').on('click', function (e) {
  $('#BIS_frame').show()
  $('#BIS_frame').contents().find('.action-close').addClass('fadein')
})

/****************************************
 * SLICK SLIDER - BLOCK RECOMMENDED
 */

$('.slick-recommended').slick({
  dots: true,
  arrows: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  mobileFirst: true,
  centerMode: false,
  centerPadding: 0,
  responsive: [
    {
      breakpoint: 768,
      settings: 'unslick'
    }
  ]
});


$('.slick-slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  asNavFor: '.product__thumbs'
});

$('.product__thumbs').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  asNavFor: '.slick-slider',
  dots: false,
  arrows: false,
  focusOnSelect: true
});

$(document).on('click', '.js-qty__adjust', function () {
  setTimeout(function () {
    $.get("/cart.js")
     .done(function (response) {
       var data = JSON.parse(response)
       var items = 0;
       data.items.forEach(function (item) {
         items += item.quantity
       });
       $('.cart-link__count').text(items)
     })
     .fail(function () {
       console.log("error");
     })
     .always(function () {
       console.log("always");
     });
  }, 1500)
});
